import {Component, Input} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {IngredientCreateInfoPage} from "../../ingredient-create/ingredient-create-info/ingredient-create-info";
import {IngredientCompCreateInfoPage} from "../../ingredient-comp-create/ingredient-comp-create-info/ingredient-comp-create-info";

/**
 * Generated class for the IngredientViewTagsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ingredient-view-tags',
    templateUrl: 'ingredient-view-tags.html',
})
export class IngredientViewTagsPage {
    @Input() ingredient: any;
    tags: any = [];

    constructor(public navCtrl: NavController,
                public navParams: NavParams) {
    }

    edit() {
        if (this.ingredient.sub_recipe == false) {
            this.navCtrl.push(IngredientCreateInfoPage, {
                update_state: true,
                ingredient_uid: this.ingredient.UID,
                ingredient_name: this.ingredient.name,
                measurement: this.ingredient.measurement,
                stock: this.ingredient.stock,
                stock_alert: this.ingredient.stock_alert,
                tags: this.ingredient.tags
            })
        } else {
            this.navCtrl.push(IngredientCompCreateInfoPage, {
                update_state: true,
                ingredient_uid: this.ingredient.UID,
                ingredient_name: this.ingredient.name,
                measurement: this.ingredient.measurement,
                stock: this.ingredient.stock,
                stock_alert: this.ingredient.stock_alert,
                tags: this.ingredient.tags
            })
        }
    }


}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-view/ingredient-view-tags/ingredient-view-tags.ts